@if (viewLoaded) {
	<article class="comments module widget">
		@if (canCreateComments()) {
			<form class="form" [formGroup]="group">
				<div class="input-container relative">
					<textarea
						formControlName="newComment"
						(focus)="setShowButton(true)"
						(stagesClickOutside)="setShowButton(false)"
						id="newComment"
						name="newComment"
						rows="0"
						[placeholder]="'process.element.comments.placeholder' | translate"
						stagesAutoGrow
						class="icon-spacer"
					></textarea>
					<i class="ico ico-smile"></i>
					<div class="info">
						<div class="errors">
							@for (error of getErrors("newComment"); track error) {
								@switch (error) {
									@case ("maxlength") {
										<div
											class="error"
											[translate]="'input.maxLength'"
											[translateParams]="{ length: commentMaxLength }"
											role="alert"
										></div>
									}
								}
							}
						</div>
						<div class="maxlength">{{ getCommentLengthInfo("newComment") }}</div>
					</div>
				</div>
				<div [hidden]="!showButton" class="input-container right">
					<button
						[disabled]="!isSubmitAllowed('newComment')"
						(click)="addComment()"
						class="button sm save"
						translate="add"
					></button>
				</div>
			</form>
		}
		@if (getTotalCommentCount()) {
			<h3 [translate]="getCommentCountMessageKey()" [translateParams]="{ count: getTotalCommentCount() }"></h3>
		}
		@if (hasComments()) {
			<ul class="list" [formGroup]="group">
				@for (comment of getItems(); track comment; let last = $last) {
					<li class="list-item">
						<div class="label">
							<div class="avatar-cell">
								<stages-user-image
									[userName]="comment.creator.fullname"
									userId="{{ comment.creator.id }}"
									version="{{ comment.creator.profileImageVersion }}"
								></stages-user-image>
							</div>
							<div class="text fullsize center">
								<div>
									<a class="user clickable"
										><h4>{{ comment.creator.fullname }}</h4></a
									>
									<h6>{{ comment.creationDate }}</h6>
									@if (comment.modified) {
										<h6 [translate]="'process.element.comments.modified'" [translateParams]="comment"></h6>
									}
								</div>
								@if (!isEditOn(comment.id)) {
									<p class="preformatted">{{ comment.value }}</p>
								}
								@if (isEditOn(comment.id)) {
									<div class="relative">
										<textarea
											[formControlName]="'comment' + comment.id"
											id="comment"
											name="comment"
											rows="0"
											[placeholder]="'process.element.comments.placeholder' | translate"
											stagesAutoGrow
											class="icon-spacer"
										></textarea>
										<i class="ico ico-smile"></i>
										<div class="info">
											<div class="errors">
												@for (error of getErrors("comment" + comment.id); track error) {
													@switch (error) {
														@case ("maxlength") {
															<div
																class="error"
																[translate]="'input.maxLength'"
																[translateParams]="{ length: commentMaxLength }"
																role="alert"
															></div>
														}
													}
												}
											</div>
											<div class="maxlength">{{ getCommentLengthInfo("comment" + comment.id) }}</div>
										</div>
										<div class="buttons">
											<button
												class="sm cancel button-space-right"
												(click)="cancelEdit(comment.id)"
												translate="cancel"
											></button>
											<button
												class="sm save"
												(click)="saveEditExistingComment(comment, 'comment' + comment.id)"
												[disabled]="!isSubmitAllowed('comment' + comment.id)"
												translate="save"
											></button>
										</div>
									</div>
								}
							</div>
							@if (!isEditOn(comment.id)) {
								<stages-menu
									class="action"
									[menuId]="'commentMenu'"
									iconClasses="ico ico-more-vertical"
									openTo="bottom"
									[items]="getMenuItems(comment)"
								></stages-menu>
							}
						</div>
					</li>
					@if (!last) {
						<li class="divider"></li>
					}
					@if (last && isShowMoreButtonDisplayed()) {
						<li class="list-item">
							<div class="label">
								<div class="avatar-cell"></div>
								<a class="label clickable" (click)="loadMore()">
									<i class="ico ico-refresh"></i>
									<h4 class="text">{{ "process.element.comments.showMore" | translate }}</h4>
								</a>
							</div>
						</li>
					}
				}
			</ul>
		}
		@if (!hasComments() && !canCreateComments()) {
			<p class="empty" translate="none"></p>
		}
	</article>
}
